import { Component } from '@angular/core';
import faqData from './faq.json';

interface FaqItem {
    question: string;
    answer: string;
}

interface FaqSection {
    id: string;
    title: string;
    faqs: FaqItem[];
}

@Component({
    selector: 'vb-faq-page',
    templateUrl: './faq-page.component.html',
    styleUrls: ['./faq-page.component.scss'],
})
export class FaqPageComponent {
    public sections: FaqSection[] = faqData;

    public getParagraphs(answer: string): string[] {
        return answer
            .split(/\n\s*\n/)
            .map((paragraph: string) => paragraph.trim())
            .filter((paragraph: string) => paragraph.length > 0);
    }
}
